import { getDicts } from "@/api/request";
const dict = {
    state: {
        dicts: {
            // 设备分类
            equipmentClassificationList: [
                { dictLabel: "云现场", dictValue: 1 },
                { dictLabel: "材料检测", dictValue: 2 },
                { dictLabel: "高端测试", dictValue: 3 },
                { dictLabel: "材料加工", dictValue: 4 },
                { dictLabel: "试剂耗材", dictValue: 5 },
                { dictLabel: "环境检测", dictValue: 6 },
                { dictLabel: "模拟计算", dictValue: 7 },
                { dictLabel: "数据分析", dictValue: 8 }
            ],
            // 支付方式
            prepaidPayment: [
                { dictValue: 1, dictLabel: "个人预存" },
                { dictValue: 2, dictLabel: "团队预存" },
                { dictValue: 3, dictLabel: "支付宝" },
                { dictValue: 4, dictLabel: "微信" },
                { dictValue: 5, dictLabel: "个人信用" },
                { dictValue: 6, dictLabel: "团队信用" },
            ],
            // 订单管理-订单状态 待支付/待分配/待确认/待实验/实验中/待结算/已完成
            isOrderStatus: [
                { dictValue: 1, dictLabel: "待支付" },
                { dictValue: 2, dictLabel: "待分配" },
                { dictValue: 3, dictLabel: "待确认" },
                { dictValue: 4, dictLabel: "待实验" },
                { dictValue: 5, dictLabel: "实验中" },
                { dictValue: 6, dictLabel: "待结算" },
                { dictValue: 7, dictLabel: "已完成" },
                { dictValue: 8, dictLabel: "已取消" },
                { dictValue: 9, dictLabel: "申请开票" },
                { dictValue: 10, dictLabel: "待审核" },
                { dictValue: 11, dictLabel: "审核拒绝" },
                { dictValue: 12, dictLabel: "待核对" },
                { dictValue: 13, dictLabel: "沟通中" },
            ],
            //发票状态
            invoiceStatus: [
                { dictValue: 1, dictLabel: "待核销" },
                { dictValue: 2, dictLabel: "待结清" },
                { dictValue: 3, dictLabel: "已完结" },
            ],
            //发票状态
            invoiceOrderStatus: [
                { dictValue: 1, dictLabel: "未开票" },
                { dictValue: 2, dictLabel: "已开票" },
                { dictValue: 3, dictLabel: "无需开票" },
            ],
            //回款状态
            paymentStatus: [
                { dictValue: 1, dictLabel: "否" },
                { dictValue: 3, dictLabel: "是" },
            ],
            // 邮寄方式
            postMethod: [
                { dictValue: 1, dictLabel: "自行邮寄" },
                { dictValue: 2, dictLabel: "上门取样" },
                { dictValue: 3, dictLabel: "自己送样" },
            ],
            //发票类型
            invoiceType: [
                { dictValue: 1, dictLabel: "普通发票" },
                { dictValue: 2, dictLabel: "专用发票" },
            ],
            //我的发票-发票状态
            myInvoiceStatus: [
                { key: 'invoiceStatus', dictValue: '', dictLabel: "全部发票", index: 0 },
                { key: 'invoiceStatus', dictValue: 1, dictLabel: "开票中", index: 1 },
                { key: 'invoiceStatus', dictValue: 3, dictLabel: "已开票", index: 2 },
                { key: 'invoiceStatuss', dictValue: '4,6', dictLabel: "已销毁/失败", index: 3 },
            ],
            //预存来源
            pretoreType: [
                { dictValue: 1, dictLabel: "个人" },
                { dictValue: 2, dictLabel: "团队" },
                { dictValue: 3, dictLabel: "划拨" },
            ],
            //团队人员职责
            characterRole: [
                { dictValue: 3, dictLabel: "团员" },
                { dictValue: 1, dictLabel: "团长" },
                { dictValue: 2, dictLabel: "管理员" },
            ],
            //审核状态
            checkStatus: [
                { dictValue: 1, dictLabel: "待审核" },
                { dictValue: 2, dictLabel: "审核通过" },
                { dictValue: 3, dictLabel: "审核拒绝" },
            ],
            // 获取方式1 兑换 2奖励 3实名认证 4测试费用到账 5预存赠送
            grantType: [
                { dictValue: 1, dictLabel: "兑换" },
                { dictValue: 2, dictLabel: "奖励积分" },
                { dictValue: 3, dictLabel: "实名认证" },
                { dictValue: 4, dictLabel: "消费赠送" },
                { dictValue: 5, dictLabel: "预存奖励" },
            ],
        }
    },
    mutations: {
        SET_DICT: (state, payload) => {
            state.dicts = {
                ...state.dicts,
                ...payload
            }
        }
    },
    actions: {
        async getDictByKey({ commit, state }, dictKey) {
            if (state.dicts[dictKey]) {
                return state.dicts[dictKey]
            }
            const res = await getDicts(dictKey)
            commit('SET_DICT', {
                [dictKey]: res.data || []
            })
            return res.data || []
        }
    }
}

export default dict